const education = [
  {
    title: 'Software Engineering Immersive',
    start: 'Mar 2020',
    end: 'Sep 2020',
    description: ['General Assembly', 'Covers mainly MERN Stack', '4 projects, including one group project', '480 hours of instruction']
  },
  {
   title: 'BEng (Civil)',
   start: '2005',
   end: '2009',
   description: ['National University of Singapore']
  },
]

export default education;
